import {AppSettingsService} from "@app/lib/b2b-services/mobile-app/app-settings.service";
import {Capacitor} from "@capacitor/core";
import {inject} from "@angular/core";

export function initializeApp() {
  const appSettingsService: AppSettingsService = inject(AppSettingsService);
  

  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
    appSettingsService.checkMobileAppVersion();
  }

}
